import { createStore } from 'owa-satcheljs';
import type DrawerPaneState from './schema/DrawerPaneState';
import { type DrawerPaneInfo } from './schema/DrawerPaneState';

const defaultStore: DrawerPaneState = {
    paneStateMap: new Map<string, Map<string, DrawerPaneInfo>>(),
};

export const getStore: () => DrawerPaneState = createStore<DrawerPaneState>(
    'DrawerPaneStore',
    defaultStore
);
